export default "__VITE_ASSET__DPpxvXJs__"